// Lib
import { connect } from 'react-redux';

// Constants
import { LIVE_COLLABORATION_STORE_NAME } from '../liveCollaborationConstants';

export default (...args) => {
    const opts = {
        ...args[3],
        storeKey: LIVE_COLLABORATION_STORE_NAME,
        getDisplayName: (component) => `LiveCollaborationStoreConnect(${component})`,
    };
    return connect(args[0], args[1], args[2], opts);
};
